export default __webpack_public_path__ + "static/munmun-9e77eebcdd81952b2e3bbebfb9d27610.jpg";